module.exports = __webpack_public_path__ + "img/top-10-list-view.d8490718.webp";